import p1_img from './product_1.png'
import p2_img from './product_2.png'
import p3_img from './product_3.png'
import c2_img from './cx.jpg'
import i2_img from './02.jpg'
import c3_img from './c3.jpg'
import p4_img from './product_4.png'
import c1_img from './cy.jpg'
import c4_img from './c4.jpg'

let data_product = [
  {
    id:1,
    name:"Above Knee Knot Dress",
    image:c1_img,
    new_price:50.00,
    old_price:80.50,
  },
  {id:2,
    name:"Long Sleeves Short Cut-Out Dress",
    image:c2_img,
    new_price:85.00,
    old_price:120.50,
  },
  {id:3,
    name:"Jacquard Mini Dress in Blue Floral",
    image:c3_img,
    new_price:60.00,
    old_price:100.50,
  },
  {id:4,
    name:"ADIVAN Short Dress",
    image:c4_img,
    new_price:100.00,
    old_price:150.00,
  },
];

export default data_product;
